/**
 * enumerated class for choice the component type of message
 * */
export enum MessageComponentType {
	SNACK_BAR,
	FLASH_MESSAGE
}

export const EMPTY_MESSAGE: string = 'Attenzione messaggio non mappato correttamente';

/**
 * enumerated class for choice the type of message
 * */
export enum MessageType {
	TYPE_SUCCESS = 'success',
	TYPE_WARNING = 'warning',
	TYPE_ERROR = 'error',
	TYPE_INFO = 'info',
}

export enum SnackBarClasses {
	SUCCESS = 'snack-bar-success',
	ERROR = 'snack-bar-error',
	WARNING = 'snack-bar-warning',
	INFO = 'snack-bar-info'
}

export interface MessageCodeAndComponentType {
	messageCode: string;
	componentType: MessageComponentType;
}

/**
 * enumerated class for common messages codes
 * */
export enum CommonMessageCode {
	DELETE_ALL = 'DELETE_ALL',
	GENERIC_SUCCESS = 'GENERIC_SUCCESS',
	GENERIC_ERROR = 'GENERIC_ERROR',
	EMPTY_MESSAGE = 'EMPTY_MESSAGE',
	FILE_DOWNLOAD_KO = 'FILE_DOWNLOAD_KO',
	SUPER_USER_GATEWAY_1002 = 'SUPER_USER_GATEWAY_1002',
	FILE_UPLOAD_OK = 'FILE_UPLOAD_OK',
	FILE_UPLOAD_KO = 'FILE_UPLOAD_KO',
	ERROR_DURING_FILE_CONVERSION = 'ERROR_DURING_FILE_CONVERSION',
	ASYNC_EXPORT_SUCCESS = 'ASYNC_EXPORT_SUCCESS',
	ERROR_EXPORT_MAX_EXCEED = 'ERROR_EXPORT_MAX_EXCEED',
}


/**
 * the main interface that specify the detail of the message
 * the service that uses and manage this class {@link MessageManagerService#pushInnerMessage}
 * */
export interface MessageDetail<T = string> {
	/** IT'S REQUIRED, refers to the key of the message in the relative module json messages file*/
	code: CommonMessageCode | string | T;

	/** IT'S OPTIONAL, it's an additional string that can contain optional parameter for the message
	 *  IMPORTANT
	 *  for every parameter you have to insert it into a special token (''), example: ('26 february 2020'),
	 *  if you have multi parameter you have to concat every special token in the way you want to display it
	 *  example: `('hello') ('how') ('are you?')`
	 * */
	message?: string;

	/** IT'S REQUIRED, it refers to the type of the message that you want to display*/
	type: MessageType;

	/** IT'S REQUIRED, it refers to the component that you want to use for display the message*/
	componentType: MessageComponentType;

	/** IT'S OPTIONAL, it refers to the delay time for auto-delete the message*/
	delay?: number;

	/** IT'S OPTIONAL, default value = true, you have to set it to false if you want to display the message into another place in the HTML*/
	isTop?: boolean;

	/** IT'S OPTIONAL, default value = true, you have to set it to false if you want to block the displayed message*/
	enableAutoDelete?: boolean;

	/** IT'S OPTIONAL, default value = false, you have to set it to true if you want to keep the message when route change*/
	keepAlive?: boolean;
}

export class MessageModel {
	static DELAY: number = 20000;

	type: string;
	autoDeleteEnable: boolean;
	id: string;
	state: string;
	removing: boolean;
	keepAlive: boolean;
	autoDeleteDelay: number;
	componentType: MessageComponentType;
	isTop: boolean;

	constructor(
		id: string,
		type: string,
		autoDeleteEnable: boolean = true,
		componentType: MessageComponentType = MessageComponentType.FLASH_MESSAGE,
		isTop: boolean = true,
		keepAlive: boolean = false,
		autoDeleteDelay?: number,
	) {
		this.id = id;
		this.type = type;
		this.autoDeleteEnable = autoDeleteEnable;
		this.removing = false;
		this.keepAlive = keepAlive;
		this.autoDeleteDelay = autoDeleteDelay || MessageModel.DELAY;
		this.componentType = componentType;
		this.isTop = isTop;
	}
}
